import { useSearchParams as useNextSearchParams } from 'next/navigation'

export function useSearchParam(param: string) {
  const params = useNextSearchParams()

  return params.get(param)
}
